import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { Ticket, TicketTypeBundle } from 'types/TicketsState';
import { dateFormatForCalendar } from 'utils/calendar';
import TicketSection from '.';
import useEmbedResize from 'utils/custom-hooks/useEmbedResize';
import { onResize } from 'utils/embed';
import {
  getGroupItemsTree,
  isTicketType,
  isTicketTypeBundle,
} from '../TicketSaleCard/getItemsTree';
import TicketTypeBundleSection from '../TicketTypeBundleSection';

interface TicketGroupProps {
  id: number;
  name: string;
  tickets: Ticket[];
  bundles: TicketTypeBundle[];
  selectedDate?: DateTime;
  handleOpenChart?: () => void;
}

const TicketGroup: React.FC<TicketGroupProps> = ({
  id,
  name,
  tickets,
  bundles,
  selectedDate,
  handleOpenChart,
}) => {
  const [expanded, setExpanded] = useState(false);
  const groupItems = getGroupItemsTree(id, tickets, bundles);

  // useEmbedResize([expanded]);

  if (groupItems.length === 0) {
    return null;
  }

  const handleExpandAccordion = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleExpandAccordion}
      disableGutters
      sx={{
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
        '&::before': {
          display: 'none',
        },
      }}
      TransitionProps={{
        unmountOnExit: true,
        mountOnEnter: true,
        onExited: onResize,
        onEntered: onResize,
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon fontSize="medium" onClick={handleExpandAccordion} />
        }
      >
        {name}
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 0 }}>
        {groupItems.map(item =>
          isTicketType(item) ? (
            <TicketSection
              key={
                selectedDate
                  ? `${item.id}-${selectedDate.toFormat(dateFormatForCalendar)}`
                  : item.id
              }
              ticket={item}
              handleOpenChart={handleOpenChart}
            />
          ) : isTicketTypeBundle(item) ? (
            <TicketTypeBundleSection
              key={
                selectedDate
                  ? `${item.id}-${selectedDate.toFormat(dateFormatForCalendar)}`
                  : item.id
              }
              ticketTypeBundle={item}
            />
          ) : null,
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default TicketGroup;
